var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.offerSets && _vm.offerSets.parts && Object.values(_vm.offerSets.parts).length > 0
  )?_c('div',[(_vm.hasManufacturerRights)?_c('calcofferitemmanufacturer',{attrs:{"offerSet":_vm.offerSets}}):_c('calcofferitemcustomer',{attrs:{"offerSet":_vm.offerSets},on:{"offer-selection-changed":_vm.offerSelectionChanged}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }